import { CoreDependencies } from "./CoreDependencies"
import { v4 as uuid } from 'uuid'
import { Logger } from "@shared/utils/Logger"
import { QontactUser } from "@shared/models/QontactUser"
import { LocalStorageController } from "./LocalStorageController"
import type { LocalStorageInterface } from "./LocalStorageInterface"

export class SharedApplication {
    private static instance: SharedApplication

    private constructor() {}
    private _coreDependencies: CoreDependencies
    private _currentUser?: QontactUser
    private _session: string
    private _token?: string
    private _organizationID?: string
    private _onSessionExpired?: () => void
    private _localStorage: LocalStorageInterface

    public static shared(): SharedApplication {
        if (!SharedApplication.instance) {
            SharedApplication.instance = new SharedApplication()
            SharedApplication.instance._session = uuid()
            SharedApplication.instance._localStorage = new LocalStorageController()
        }
        return SharedApplication.instance;
    }

    public static setDependencies(coreDependencies: CoreDependencies) {
        SharedApplication.shared()._coreDependencies = coreDependencies
    }

    public get coreDependencies(): CoreDependencies {
        return this._coreDependencies
    }

    public setToken(token: string) {
        this._token = token
        this._coreDependencies.setAPIToken(token)
    }

    public setUser(user: QontactUser) {
        this._currentUser = user
        this._coreDependencies.analytics.setUser(user)
    }

    public get user(): QontactUser {
        return this._currentUser
    }

    public get token(): string {
        return this._token
    }

    public get timezone(): string {
        return this.user.timezone ?? 'America/Argentina/Buenos_Aires'
    }

    public get session(): string {
        return this._session
    }

    public setOnSessionExpired(callback: () => void) {
        this._onSessionExpired = callback
    }

    public set organizationID(organizationID: string) {
        this._organizationID = organizationID
        this._coreDependencies.analytics.setSelectedOrganizationID(organizationID)
    }

    public get organizationID(): string {
        return this._organizationID
    }

    public get localStorageController(): LocalStorageInterface {
        return this._localStorage
    }

    public handleSessionExpired() {
        Logger.log("Application", "handle session expired")        
        this._onSessionExpired?.()
        // Optionally clear token/user here
        this._token = ''
        this._currentUser = undefined
    }
}
